<template>
  <div class="app-body">
    <el-form :inline="true" ref="queryForm" class="query-form" :model="queryForm"
             @keyup.enter.native="getDataList()">
      <el-form-item label="自定义发票号：">
        <el-input v-model="queryForm.virtualCode" size="mini" placeholder="自定义发票号" clearable></el-input>
      </el-form-item>
      <el-form-item label="出口发票号：">
        <el-input v-model="queryForm.realCode" size="mini" placeholder="出口发票号" clearable></el-input>
      </el-form-item>
      <el-form-item label="领取情况：">
        <el-select v-model="queryForm.isUse" size="mini">
          <el-option label="全部" value=""></el-option>
          <el-option label="已领取" value="1"></el-option>
          <el-option label="未领取" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用情况：">
        <el-select v-model="queryForm.isSend" size="mini">
          <el-option label="全部" value=""></el-option>
          <el-option label="已使用" value="1"></el-option>
          <el-option label="未使用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="领用时间：">
        <el-date-picker
            v-model="useDate"
            size="mini"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            clearable
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="reload()">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="$hasPermission('trade:code:save')" type="primary" @click="showGenterDialog()">
          批量生成发票号
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="$hasPermission('trade:code:save')" type="primary" @click="showSaveDialog()">
          创建发票号
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="warning" @click="doGet()">
          批量领取
        </el-button>
      </el-form-item>
    </el-form>
    <SweetTable api-version="v2" url="/erp/box/code/page" :query-form="queryForm" ref="table" :selection="true" delete-url="/erp/box/code">
      <el-table-column header-align="center" align="center"
                       label="自定义发票号"
                       min-width="160"
      >
        <template #default="{row}">
          <span>{{ row.virtualCode }}</span>
          <el-tag type="danger" v-if="$c.str2bool(row.useManName)&&row.sendCount===0" size="mini"
                  style="margin-left: 10px;">未使用
          </el-tag>
          <el-tag type="primary" v-if="row.sendCount>0" size="mini" style="margin-left: 10px;">已使用</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center"
                       prop="realCode"
                       label="出口发票号"
                       min-width="160"
      ></el-table-column>
      <el-table-column header-align="center" align="center" prop="customerName" label="客户名称"
                       min-width="90"></el-table-column>
      <el-table-column header-align="center" align="center" prop="useManName" label="领用人"
                       min-width="90"></el-table-column>
      <el-table-column header-align="center" align="center" prop="useTime" label="领用时间"
                       min-width="90"></el-table-column>
      <el-table-column header-align="center" align="center" prop="remark" label="备注"></el-table-column>
      <el-table-column header-align="center" align="center" label="操作" min-width="90" fixed="right">
        <template #default="{row}">
          <el-button type="text" size="small" v-if="$hasPermission('trade:code:set')"
                     @click="showEditDialog(row)">出口发票号
          </el-button>
          <el-button type="text" size="small" v-if="$hasPermission('trade:code:reset')&&$c.str2bool(row.useMan)"
                     @click="doReset(row)">重置
          </el-button>
          <el-button type="text" size="small" v-if="$hasPermission('trade:code:delete')"
                     @click="doDelete(row,'virtualCode')">删除
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <!-- 弹窗, 新增 / 修改 -->
    <edit-dialog ref="EditDialog" @refreshDataList="getDataList"></edit-dialog>
    <genter-dialog ref="GenterDialog" @refreshDataList="getDataList"></genter-dialog>
    <get-dialog ref="GetDialog" @refreshDataList="getDataList"></get-dialog>
    <save-dialog ref="SaveDialog" @refreshDataList="getDataList"></save-dialog>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import GenterDialog from './genter-dialog'
import EditDialog from '@/views/modules/trade/code/edit-dialog'
import GetDialog from '@/views/modules/trade/code/get-dialog'
import SaveDialog from '@/views/modules/trade/code/save-dialog'

export default {
  mixins: [SweetTable],
  data () {
    return {
      queryForm: {
        virtualCode: '',
        realCode: '',
        isUse: '',
        isSend: undefined,
        useDateBegin: '',
        useDateEnd: ''
      },
    }
  },
  computed: {
    useDate: {
      get: function () {
        return [this.queryForm.useDateBegin, this.queryForm.useDateEnd]
      },
      // setter
      set: function (newValue) {
        if (!newValue) {
          this.queryForm.useDateBegin = ''
          this.queryForm.useDateEnd = ''
        } else {
          this.queryForm.useDateBegin = newValue[0]
          this.queryForm.useDateEnd = newValue[1]
        }
      }
    }
  },
  methods: {
    async doGet () {
      let rows = this.$refs.table.dataListSelections
      if (!rows || rows.length === 0) {
        return this.$message.error('请选择要领用的发票')
      }
      this.$refs.GetDialog.init(rows.map(item => item.id), '')
    },
    showSaveDialog () {
      this.$refs.SaveDialog.init()
    },
    async doReset (row) {
      try {
        await this.$confirm(`是否重置【${row.virtualCode}】的领用情况？`)
      } catch (e) {
        return
      }
      try {
        const res = await this.$api2.post(`/erp/box/code/reset`, { id: row.id })
        this.getDataList()
        this.$message.success('操作成功')
      } catch (e) {
        console.log(e)
      }
    },
    showEditDialog (row) {
      this.$refs.EditDialog.init(row.id)
    },
    showGenterDialog () {
      this.$refs.GenterDialog.init()
    },

  },
  components: {
    EditDialog, GenterDialog, GetDialog, SaveDialog
  }
}
</script>
